<template>
    <div v-if="$store.state.settings.activeTab === 'Settings_Size'">
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="details ? 'Size bearbeiten' : 'Neue Size anlegen'"
                :loading="loading"
                @click:outside="close"
                @ok="submit"
                @cancel="close"
        >
            <template v-slot:button v-if="details">
                <Button :text="true" :color="ada.red" v-if="!$store.state.readOnly"
                        @click="showDeleteDialog = true">
                    Löschen
                </Button>
            </template>
            <v-row no-gutters>
                <v-col>
                    <span class="text-body-1 align-center mr-4">Typ:</span>
                    <v-btn-toggle
                        v-model="data.Type"
                        mandatory dense
                        :color="ada.pink"
                        group
                    >
                        <v-btn value="Pixel">
                            Pixel
                        </v-btn>
                        <v-btn value="Text">
                            Text
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <transition name="fastfade" mode="out-in">
                <v-row v-if="data && data.Type ? data.Type.toLowerCase() === 'pixel' : false" :key="0" no-gutters
                       class="mt-2">
                    <v-col cols="5">
                        <Input :hide-details="true" v-model.trim="data.Width" label="Breite" type="number"></Input>
                    </v-col>
                    <v-col cols="1" class="pixelDivider">
                        <span>x</span>
                    </v-col>
                    <v-col cols="5">
                        <Input :hide-details="true" v-model.trim="data.Height" label="Höhe" type="number"></Input>
                    </v-col>
                </v-row>
                <v-row v-if="data && data.Type ? data.Type.toLowerCase() === 'text' : false" :key="1" no-gutters
                       class="mt-2">
                    <v-col cols="12">
                        <Input :hide-details="true" v-model.trim="data.Text" label="Text"></Input>
                    </v-col>
                </v-row>
            </transition>
            <v-row no-gutters class="mt-2">
                <v-col cols="12">
                    <Toggle v-model="data.IsFavourite" label="Favorit"></Toggle>
                </v-col>
            </v-row>
        </Dialog>
        <DeleteSizeDialog v-model="showDeleteDialog" @deleted="close"></DeleteSizeDialog>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Input from "../../../components/Inputs/Input";
import Button from "../../../components/buttons/Button";
import Toggle from "../../../components/buttons/Toggle";
import ada from "../../../scss/ada_colors.scss";
import DeleteSizeDialog from "./DeleteSizeDialog";

export default {
    name: "AddEditSizeDialog",
    props: ['value'],
    components: {DeleteSizeDialog, Toggle, Button, Input, Dialog},
    data: () => {
        return {
            data: {
                Type: 'Pixel',
                Width: null,
                Height: null,
                Text: '',
                IsFavourite: 0,
            },
            loading: false,
            showDeleteDialog: false,
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        details() {
            return this.$store.state.settings.selectedDetails;
        },
    },
    methods: {
        init() {
            if (this.details) {
                this.data = JSON.parse(JSON.stringify(this.details));
            } else {
                this.data = {
                    Type: 'Pixel',
                    Width: null,
                    Height: null,
                    Text: null,
                    IsFavorite: 0,
                }
            }
        },
        async submit() {
            this.loading = true;
            try {
                let data = await this.$store.dispatch('settings/editSize', this.getBody());
                this.loading = false;
                if (data.Status) {
                    let msg = this.details ? 'Erfolgreich gespeichert.' : 'Size erfolgreich angelegt.';
                    this.$root.$emit('snackbar', msg);
                    this.close();
                    this.close();
                }
            } catch (e) {
                this.loading = false;
            }
        },
        getBody() {
            let json = {
                Type: this.data.Type,
                IsFavorite: this.data.IsFavorite,
                Width: this.data.Type === 'Pixel' ? this.data.Width : 0,
                Height: this.data.Type === 'Pixel' ? this.data.Height : 0,
                Text: this.data.Type === 'Text' ? this.data.Text : '',
            };
            if (this.details) json.size_id = this.details.ConfigSizeId;
            return json;
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.init();
            this.$emit('input', false); // set v-model to false -> close dialog
        },
    },
    watch: {
        value() {
            if (this.$store.state.settings.activeTab === 'Settings_Size') this.init();
        }
    }
}
</script>

<style lang="scss" scoped>
.label {
    font-size: 1.1em;
}

.pixelDivider {
    display: flex;
    align-items: center;
    position: relative;
    top: -5px;
    font-weight: 400;
    font-size: 1.2em;
    width: 100%;
    text-align: center;
}
</style>